import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Typography,
  Paper,
  Checkbox,
  Grid,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Alert,
  Avatar,
  Snackbar,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Chip,
  Autocomplete,
  CircularProgress,
} from '@mui/material';
import {
  ArrowBack,
  Save,
  Add as AddIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  LocationOn,
  Edit as EditIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { decryptAppId, decryptText, encryptText, encryptAppId } from '../../../utils/encryption';
import LaboratoryService from '../../../services/laboratoryService';
import acProcessService, { getApplicationsByOrgIdPrevious, pullScopesFromPreviousApp, pullDANCFromPreviousApp, getPrevDataTransfer } from '../../../services/acProcessService';
import axios from 'axios';
import {
  insertDANC,
  updateDANCBySourceIdEditCertificate,
  getDANC,
} from '../../../services/apiCalibration';
import { getScrutinyRemarks, getClauseNo } from '../../../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const EditScopeCertificate = (data) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get encrypted parameters from URL
  const encryptedAppId = searchParams.get("appId");
  const encryptedOrgId = searchParams.get("orgId");
  const encryptedAssessmentId = searchParams.get("assessmentId");

  // Decrypt parameters
  const appIdFromUrl = encryptedAppId ? decryptAppId(encryptedAppId) : null;
  const orgIdFromUrl = encryptedOrgId ? decryptText(encryptedOrgId) : null;
  const assessmentIdFromUrl = encryptedAssessmentId ? decryptText(encryptedAssessmentId) : null;

  // State management
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [appId] = useState(appIdFromUrl);
  const [orgId] = useState(orgIdFromUrl);
  const [assessmentId] = useState(assessmentIdFromUrl);

  // Lab Details States
  const [labTypeId, setLabTypeId] = useState('');
  const [labName, setLabName] = useState('');
  const [country, setCountry] = useState('India');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [district, setDistrict] = useState('');
  const [subDistrict, setSubDistrict] = useState('');
  const [address, setAddress] = useState('');
  const [pincode, setPincode] = useState('');
  const [salutation, setSalutation] = useState('Mr.');
  const [contactName, setContactName] = useState('');
  const [designation, setDesignation] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [landlineCode, setLandlineCode] = useState('');
  const [landlineNo, setLandlineNo] = useState('');
  const [faxCode, setFaxCode] = useState('');
  const [faxNo, setFaxNo] = useState('');
  const [email, setEmail] = useState('');
  const [legalEntityName, setLegalEntityName] = useState('');
  const [additionalData, setAdditionalData] = useState('');

  // Dropdown data
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);

  // Scope Details States
  const [existingScopes, setExistingScopes] = useState([]);
  const [existingScopesLoading, setExistingScopesLoading] = useState(false);
  const [existingScopesPage, setExistingScopesPage] = useState(1);
  const [existingScopesPageSize, setExistingScopesPageSize] = useState(50);
  const [existingScopesTotalPages, setExistingScopesTotalPages] = useState(1);
  const [existingScopesTotalRecords, setExistingScopesTotalRecords] = useState(0);
  const [existingScopesSearchQuery, setExistingScopesSearchQuery] = useState('');
  // DA-NC and bulk adequacy states
  const [dancRecords, setDancRecords] = useState([]);
  const [selectedAdequacyScopes, setSelectedAdequacyScopes] = useState([]);
  const [bulkAdequacyModalOpen, setBulkAdequacyModalOpen] = useState(false);
  const [bulkAdequacyStatus, setBulkAdequacyStatus] = useState('');
  const [bulkAdequacyRemarks, setBulkAdequacyRemarks] = useState('');
  const [bulkAdequacyLoading, setBulkAdequacyLoading] = useState(false);
  const [bulkScrutinyRemarks, setBulkScrutinyRemarks] = useState([]);
  const [bulkLoadingRemarks, setBulkLoadingRemarks] = useState(false);
  const [clauseList, setClauseList] = useState([]);
  const [selectedClause, setSelectedClause] = useState(null);
  const userTypeId = localStorage.getItem('userTypeId');
  const currentUserId = parseInt(localStorage.getItem('userId') || localStorage.getItem('orgId') || '0', 10);

  // Pull from previous application states
  const [pullAppModalOpen, setPullAppModalOpen] = useState(false);
  const [pullAppList, setPullAppList] = useState([]);
  const [pullAppLoading, setPullAppLoading] = useState(false);
  const [pullingFromAppId, setPullingFromAppId] = useState(null);
  const [hasPulled, setHasPulled] = useState(false);
  const [pullConfirmOpen, setPullConfirmOpen] = useState(false);
  const [pullConfirmData, setPullConfirmData] = useState(null);

  // Edit Modal State
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [editingScopeId, setEditingScopeId] = useState(null);
  const [editReadOnlyData, setEditReadOnlyData] = useState({});
  const [editLoading, setEditLoading] = useState(false);
  const [formData, setFormData] = useState({
    disciplineId: "",
    disciplineName: "",
    appId: "",
    orgId: "",
    ...data,
  });


  // Get disciplineId and disciplineName from localStorage or URL
  const [disciplineId] = useState(localStorage.getItem('currentDisciplineId') || '');
  const [disciplineName] = useState(localStorage.getItem('currentDisciplineName') || '');
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null); // 'single' or 'multiple'
  const [singleDeleteId, setSingleDeleteId] = useState(null);
  // Combined selection state for both delete and bind operations on existing scopes
  const [selectedExistingScopes, setSelectedExistingScopes] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  // Scope Master Data State
  const [scopeMasterData, setScopeMasterData] = useState([]);
  const [scopeMasterLoading, setScopeMasterLoading] = useState(false);
  const [selectedScopes, setSelectedScopes] = useState([]);
  const [selectedScopeData, setSelectedScopeData] = useState([]); // Store complete data for selected scopes across all pages
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [disciplineList, setDisciplineList] = useState([]);
  const [selectedDisciplineId, setSelectedDisciplineId] = useState("");
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Facility details state
  const [facilities, setFacilities] = useState([]);
  const [adequacyFilter, setAdequacyFilter] = useState('All');
  const [facilitiesLoading, setFacilitiesLoading] = useState(false);
  // Snackbar
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });

  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  // ReactQuill configuration
  const quillModules = {
    toolbar: [
      [{ 'font': ['Times New Roman'] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean']
    ],
  };

  const quillFormats = [
    'font', 'size', 'bold', 'italic', 'underline', 'list', 'bullet'
  ];

  // DA-NC helpers
  const fetchDANCRecords = async () => {
    if (!orgId || !appId) return;
    try {
      const resp = await getDANC({
        orgid: orgId,
        appid: appId
      });
      if (resp && resp.data && resp.data.success) {
        setDancRecords(resp.data.data || []);
      } else if (resp && resp.data) {
        setDancRecords(resp.data.data || []);
      } else {
        setDancRecords([]);
      }
    } catch (err) {
      console.error('Error loading DA-NC records:', err);
      setDancRecords([]);
    }
  };

  const fetchBulkScrutinyRemarks = async () => {
    setBulkLoadingRemarks(true);
    try {
      const responseApi = await getScrutinyRemarks({ sectionName: 'Scope', type: userTypeId === '6' ? 'Assessment' : 'Document Review' });
      const response = responseApi.data;
      if (response && response.success && response.data) {
        setBulkScrutinyRemarks(response.data);
      } else {
        setBulkScrutinyRemarks([]);
      }
    } catch (error) {
      console.error('Error fetching scrutiny remarks:', error);
      setBulkScrutinyRemarks([]);
    } finally {
      setBulkLoadingRemarks(false);
    }
  };

  const fetchClauseList = async () => {
    try {
      const clauseResponse = await getClauseNo({ standard: '2022', feild: 'Medical' });
      if (clauseResponse && clauseResponse.data) {
        setClauseList(clauseResponse.data);
      }
    } catch (err) {
      console.error('Error fetching clause list:', err);
      setClauseList([]);
    }
  };

  const handleOpenBulkAdequacyModal = async () => {
    if (!selectedAdequacyScopes || selectedAdequacyScopes.length === 0) {
      showSnackbar('Please select at least one scope to mark adequacy', 'warning');
      return;
    }
    await fetchBulkScrutinyRemarks();
    if (userTypeId === '6') await fetchClauseList();
    await fetchDANCRecords();
    setBulkAdequacyModalOpen(true);
  };

  const handleCloseBulkAdequacyModal = () => {
    setBulkAdequacyModalOpen(false);
    setBulkAdequacyStatus('');
    setBulkAdequacyRemarks('');
    setSelectedClause(null);
  };

  const handleAdequacyScopeSelection = (scopeId, isSelected) => {
    if (isSelected) {
      setSelectedAdequacyScopes((prev) => [...prev, scopeId]);
    } else {
      setSelectedAdequacyScopes((prev) => prev.filter((id) => id !== scopeId));
    }
  };

  const handleSelectAllAdequacyScopes = (isSelected) => {
    if (isSelected) {
      setSelectedAdequacyScopes(existingScopes.map((s) => s.Id));
    } else {
      setSelectedAdequacyScopes([]);
    }
  };

  const handleBulkAdequacySubmit = async () => {
    if (!bulkAdequacyStatus || (bulkAdequacyStatus === 'Inadequate' && !bulkAdequacyRemarks?.trim()) || (bulkAdequacyStatus === 'Inadequate' && userTypeId === '6' && !selectedClause)) {
      showSnackbar('Please fill required fields for bulk adequacy', 'error');
      return;
    }

    setBulkAdequacyLoading(true);
    try {
      let successCount = 0;
      let errorCount = 0;
      const errors = [];

      let ncType = 'Assessment';
      if (userTypeId === '4') ncType = 'Assessment';
      else if (userTypeId === '6') ncType = 'Assessment';

      for (const scopeId of selectedAdequacyScopes) {
        try {
          // Check for existing DA-NC record in dancRecords (try different field name cases)
          const existingRecord = dancRecords.find((r) => {
            const sourceId = r.sourceid || r.sourceId || r.SourceId || r.sourceid;
            return sourceId && parseInt(sourceId) === parseInt(scopeId);
          });

          // Also check if the scope itself has DA-NC information
          const scopeRecord = existingScopes.find((s) => parseInt(s.Id) === parseInt(scopeId));
          const hasExistingDANC = existingRecord || (scopeRecord && scopeRecord.InformationStatus);

          // Use the lab's orgId from scope record, fallback to state orgId
          const labOrgId = scopeRecord?.OrgId || orgId;
          console.log('Processing scope:', { scopeId, labOrgId, appId, assessmentId, hasExistingDANC });

          if (hasExistingDANC) {
            const updateData = {
              subsectionName: 'Scope Details',
              informationStatus: bulkAdequacyStatus,
              observation: bulkAdequacyStatus === 'Inadequate' ? bulkAdequacyRemarks : 'Document adequacy check completed',
              NCtype: ncType,
              sourceid: scopeId,
              isactive: 1,
            };

            if (userTypeId === '6' && selectedClause) {
              updateData.ClauseNo = selectedClause?.ClauseNo || selectedClause?.DisplayName || selectedClause;
            }

            const resp = await updateDANCBySourceIdEditCertificate(labOrgId, appId, 'Scope', scopeId, localStorage.getItem('orgId') || 0, assessmentId || 0, updateData);
            if (resp && resp.data && (resp.data.success || resp.status === 200)) {
              successCount++;
            } else {
              throw new Error(resp.data?.message || 'Failed to update DA-NC');
            }
          } else {
            const baseBulkDANCData = {
              Orgid: parseInt(labOrgId),
              Appid: parseInt(appId),
              SectionName: 'Scope',
              SubsectionName: 'Scope Details',
              InformationProvided: bulkAdequacyRemarks || '',
              InformationStatus: bulkAdequacyStatus,
              observation: bulkAdequacyStatus === 'Inadequate' ? bulkAdequacyRemarks : 'Document adequacy check completed',
              sourceid: scopeId,
              Insertedby: currentUserId,
              NCtype: ncType,
            };

            if (userTypeId === '6' && selectedClause) {
              baseBulkDANCData.ClauseNo = selectedClause?.ClauseNo || selectedClause?.DisplayName || selectedClause;
            }

            const dancData = userTypeId === '6' ? { ...baseBulkDANCData, assessmentId: assessmentId || 0, assessorId: localStorage.getItem('orgId') || 0 } : baseBulkDANCData;

            const resp = await insertDANC(dancData);
            if (resp && resp.data && (resp.data.success || resp.status === 200)) {
              successCount++;
            } else {
              throw new Error(resp.data?.message || 'Failed to create DA-NC record');
            }
          }
        } catch (err) {
          console.error('Error processing scope', scopeId, err);
          errors.push(`${scopeId}: ${err.message}`);
          errorCount++;
        }
      }

      if (successCount > 0) {
        showSnackbar(`Bulk adequacy completed: ${successCount} processed${errorCount ? `, ${errorCount} failed` : ''}`, errorCount ? 'warning' : 'success');
        loadExistingScopes();
      }

      if (errors.length) console.error('Bulk adequacy errors:', errors);

      await fetchDANCRecords();
      setSelectedAdequacyScopes([]);
      handleCloseBulkAdequacyModal();
    } catch (err) {
      console.error('Error submitting bulk adequacy:', err);
      showSnackbar('Error submitting bulk adequacy: ' + (err.message || ''), 'error');
    } finally {
      setBulkAdequacyLoading(false);
    }
  };

  useEffect(() => {
    if (existingScopes.length > 0) {

      const uniqueDisciplines = [
        ...new Map(
          existingScopes.map((item) => [
            item.DisciplineId,
            {
              DisciplineId: item.DisciplineId,
              disciplineName: item.disciplineName,
            },
          ])
        ).values(),
      ];

      setDisciplineList(uniqueDisciplines);
    }
  }, [existingScopes]);

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleOpenPullAppModal = async () => {
    setPullAppModalOpen(true);
    setPullAppLoading(true);
    const orgIdDO = localStorage.getItem('ViewApp_OrgId');
    try {
      const result = await getApplicationsByOrgIdPrevious(orgIdDO);
      if (result && result.data) {
        setPullAppList(result.data);
      } else {
        setPullAppList([]);
      }
    } catch (err) {
      console.error('Error fetching applications:', err);
      setPullAppList([]);
    } finally {
      setPullAppLoading(false);
    }
  };

  const handleClosePullAppModal = () => {
    setPullAppModalOpen(false);
    setPullAppList([]);
  };

  const handlePullFromApp = async (sourceAppId, rowIdx) => {
    setPullingFromAppId(rowIdx);
    const orgidLab = localStorage.getItem('ViewApp_OrgId');
    try {
      const result = await pullScopesFromPreviousApp(appId, sourceAppId, orgidLab);
      if (result && (result.success || result.status === 'success')) {
        try {
          await pullDANCFromPreviousApp(appId, sourceAppId, orgidLab);
        } catch (dancErr) {
          console.error('Error pulling DA-NC records:', dancErr);
        }
        setHasPulled(true);
        showSnackbar('Scope data pulled successfully!', 'success');
        loadExistingScopes();
        fetchDANCRecords();
        handleClosePullAppModal();
      } else {
        showSnackbar(result?.message || 'Failed to pull scope data', 'error');
      }
    } catch (err) {
      console.error('Error pulling scope data:', err);
      showSnackbar('Error pulling scope data: ' + (err.message || ''), 'error');
    } finally {
      setPullingFromAppId(null);
    }
  };

  const handleRequestPull = (sourceAppId, rowIdx) => {
    setPullConfirmData({ sourceAppId, rowIdx });
    setPullConfirmOpen(true);
  };

  const handleConfirmPull = () => {
    setPullConfirmOpen(false);
    if (pullConfirmData) {
      handlePullFromApp(pullConfirmData.sourceAppId, pullConfirmData.rowIdx);
    }
  };

  const handleCancelPull = () => {
    setPullConfirmOpen(false);
    setPullConfirmData(null);
  };

  // Load data on mount
  useEffect(() => {
    const fetchData = async () => {
      await loadStates();
      if (appId) {
        await initializePage();
      }
    };
    fetchData();
  }, [appId]);

  // Load existing scopes when tab changes to Scope Details
  useEffect(() => {
    if (activeTab === 1 && appId && orgId) {
      loadExistingScopes();
      fetchDANCRecords();
    }
  }, [activeTab, appId, orgId]);

  const initializePage = async () => {
    try {
      setLoading(true);

      // Load states first and get the array
      const loadedStates = await loadStates();

      // First, get application details to retrieve labTypeId
      const appResponse = await acProcessService.getApplicationDetails(appId);
      if (appResponse && appResponse.data && appResponse.data.LabTypeId) {
        const fetchedLabTypeId = appResponse.data.LabTypeId;
        setLabTypeId(fetchedLabTypeId);

        // Now fetch lab details using the API
        const response = await axios.get(
          `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/AcprocessLabdetails`,
          {
            params: {
              appid: appId,
              labtypeid: fetchedLabTypeId
            }
          }
        );

        if (response.data && response.data.isstatus) {
          await populateFormData(response.data, loadedStates);
        }
      }

      try {
        const prevTransferResult = await getPrevDataTransfer(appId);
        if (prevTransferResult && prevTransferResult.prevDataTransfer === 1) {
          setHasPulled(true);
        }
      } catch (e) {
        console.error('Error checking PrevDataTransfer:', e);
      }

      setLoading(false);
    } catch (err) {
      console.error('Error initializing page:', err);
      setError(err.message || 'Failed to load page data');
      setLoading(false);
    }
  };

  const loadStates = async () => {
    try {
      const result = await LaboratoryService.getStates();
      if (result && result.success && result.data) {
        setStates(result.data);
        return result.data;
      } else {
        showSnackbar('Failed to load states', 'error');
        return [];
      }
    } catch (error) {
      console.error('Error loading states:', error);
      showSnackbar('Error loading states', 'error');
      return [];
    }
  };

  const loadCities = async (stateId) => {
    try {
      const result = await LaboratoryService.getCitiesByState(stateId);
      if (result && result.success && result.data) {
        setCities(result.data);
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error('Error loading cities:', error);
      setCities([]);
    }
  };

  const loadDistricts = async (stateCode) => {
    try {
      const result = await LaboratoryService.getDistrictsByState(stateCode);
      if (result && result.success && result.data) {
        setDistricts(result.data);
      } else {
        setDistricts([]);
      }
    } catch (error) {
      console.error('Error loading districts:', error);
      setDistricts([]);
    }
  };

  const loadSubDistricts = async (districtCode) => {
    try {
      const result = await LaboratoryService.getSubDistrictsByDistrict(districtCode);
      if (result && result.success && result.data) {
        setSubDistricts(result.data);
      } else {
        setSubDistricts([]);
      }
    } catch (error) {
      console.error('Error loading sub-districts:', error);
      setSubDistricts([]);
    }
  };

  const populateFormData = async (data, statesArray = null) => {
    try {
      const availableStates = statesArray || states;

      setCountry(data.country || 'India');
      setLabName(data.nameLaboratory || '');
      setAddress(data.address || '');
      setPincode(data.pinCode || '');
      setContactName(data.name || '');
      setDesignation(data.designation || '');
      setMobileNo(data.mobileNo || '');
      setEmail(data.email || '');
      setLegalEntityName(data.legalentityname || '');
      setAdditionalData(data.additionaldata || '');

      if (data.landline) {
        const [code, number] = data.landline.split('-');
        setLandlineCode(code || '');
        setLandlineNo(number || '');
      }

      if (data.fax) {
        const [code, number] = data.fax.split('-');
        setFaxCode(code || '');
        setFaxNo(number || '');
      }

      if (data.state) {
        const stateIdFromApi = parseInt(data.state);
        setState(stateIdFromApi);

        const selectedState = availableStates.find(s => parseInt(s.id) === stateIdFromApi);

        if (selectedState) {
          await loadCities(selectedState.id);

          if (data.city) {
            const cityIdFromApi = parseInt(data.city);
            setCity(cityIdFromApi);
          }

          const stateCode = selectedState.State_Code || selectedState.code || selectedState.state_code || selectedState.state_id || selectedState.id;

          if (stateCode) {
            await loadDistricts(stateCode);

            if (data.district) {
              const districtCodeFromApi = data.district.toString();
              setDistrict(districtCodeFromApi);

              await loadSubDistricts(districtCodeFromApi);
            }
          }
        }
      }
    } catch (err) {
      console.error('Error populating form data:', err);
    }
  };

  const handleStateChange = async (event) => {
    const stateId = event.target.value;
    setState(stateId);
    setCity('');
    setDistrict('');
    setSubDistrict('');

    await loadCities(stateId);

    const selectedState = states.find(s => s.id == stateId);
    if (selectedState) {
      const stateCode = selectedState.State_Code || selectedState.code || selectedState.state_code || selectedState.state_id || selectedState.id;
      if (stateCode) {
        await loadDistricts(stateCode);
      }
    }
  };

  const handleDistrictChange = async (event) => {
    const districtCode = event.target.value;
    setDistrict(districtCode);
    setSubDistrict('');

    await loadSubDistricts(districtCode);
  };

  const handleUpdateLabDetails = async () => {
    try {
      if (!state) {
        showSnackbar('Please select State', 'warning');
        return;
      }
      if (!address.trim()) {
        showSnackbar('Please enter Address', 'warning');
        return;
      }
      if (!pincode.trim()) {
        showSnackbar('Please enter Pin Code', 'warning');
        return;
      }
      if (!legalEntityName.trim()) {
        showSnackbar('Please enter Legal Entity Name', 'warning');
        return;
      }
      if (!labTypeId) {
        showSnackbar('Lab Type ID is missing', 'error');
        return;
      }

      const updateData = {
        isstatus: true,
        message: '',
        appid: String(appId),
        labtypeid: String(labTypeId),
        country: '101',
        state: String(state),
        city: String(city),
        address: String(address),
        district: String(district),
        pinCode: String(pincode),
        nameLaboratory: String(labName),
        name: String(contactName),
        designation: String(designation),
        mobileNo: String(mobileNo),
        landline: landlineCode && landlineNo ? `${String(landlineCode)}-${String(landlineNo)}` : '',
        fax: faxCode && faxNo ? `${String(faxCode)}-${String(faxNo)}` : '',
        email: String(email),
        legalentityname: String(legalEntityName),
        additionaldata: String(additionalData),
        updatedby: localStorage.getItem('orgId') || '0'
      };

      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/AcprocessLabdetailsupdate`,
        updateData
      );

      if (response.data && response.data.isstatus) {
        showSnackbar(response.data.message || 'Laboratory details updated successfully', 'success');
      } else {
        showSnackbar(response.data?.message || 'Failed to update laboratory details', 'error');
      }

    } catch (err) {
      console.error('Error updating lab details:', err);
      showSnackbar(err.response?.data?.message || err.message || 'Failed to update laboratory details', 'error');
    }
  };

  const handleNumericInput = (value, maxLength) => {
    const numericValue = value.replace(/\D/g, '').slice(0, maxLength);
    return numericValue;
  };

  const handleNumericChange = (fieldName, value, maxLength) => {
    const numericValue = handleNumericInput(value, maxLength);
    handleChange(fieldName, numericValue);
  };

  const handleChange = (fieldName, value) => {
    switch (fieldName) {
      case 'pincode':
        setPincode(value);
        break;
      case 'mobileNo':
        setMobileNo(value);
        break;
      default:
        break;
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Scope Details Functions
  const loadExistingScopes = async (
    page = existingScopesPage,
    pageSize = existingScopesPageSize,
    search = existingScopesSearchQuery,
    adequacy = adequacyFilter
  ) => {
    if (!appId || !orgId) return;

    setExistingScopesLoading(true);

    try {
      const result = await LaboratoryService.getExistingScopesWithoutDisciplineId(
        appId,
        orgId,
        page,
        pageSize,
        search,
        adequacy   // send filter
      );

      if (result.success) {
        setExistingScopes(result.data);
        if (result.pagination) {
          setExistingScopesPage(result.pagination.currentPage);
          setExistingScopesPageSize(result.pagination.pageSize);
          setExistingScopesTotalPages(result.pagination.totalPages);
          setExistingScopesTotalRecords(result.pagination.totalRecords);
        }
      } else {
        setExistingScopes([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setExistingScopesLoading(false);
    }
  };

  const handleEditScope = (scope) => {
    setEditingScopeId(scope.Id);
    setEditFormData({
      rangeRemark: scope.rangeRemark || '',
      rangeType: scope.rangeType || 'Quantitative',
      RangeLL: scope.RangeLL || '',
      RangeLLUnit: scope.RangeLLUnit || '',
      RangeUL: scope.RangeUL || '',
      RangeULUnit: scope.RangeULUnit || '',
      mu: scope.mu || '',
      cv: scope.cv || '',
      cvmu: scope.CVMU || scope.CVMu || scope.cvmu || '',
      testPerformedAt: scope.testPerformedAt || '',
      EquipmentName: scope.EquipmentName || '',
      Ref_Id: scope.Ref_Id || '',
      Pt_id: scope.Pt_id || '',
    });

    setEditReadOnlyData({
      TestCode: scope.TestCode,
      disciplineName: scope.disciplineName,
      GroupTested: scope.GroupTested,
      TypeOfTest: scope.TypeOfTest,
      ScopeStandard: scope.ScopeStandard,
      PTAvailable: scope.PTAvailable,
    });

    setEditModalOpen(true);
  };
  const showNotification = (message, severity = "success") => {
    setNotification({ open: true, message, severity });
  };
  const loadScopeMasterData = useCallback(
    async (page = 1, search = "", discipline = selectedDisciplineId) => {

      if (!discipline) {
        showNotification("Please select discipline", "warning");
        return;
      }

      const labTypeId = localStorage.getItem("ViewApp_LabTypeId") || "3";

      setScopeMasterLoading(true);

      try {

        const result = await LaboratoryService.getScopeMaster(
          labTypeId,
          discipline,
          page,
          pageSize,
          search
        );

        if (result.success) {
          setScopeMasterData(result.data);
          setCurrentPage(result.pagination.currentPage);
          setTotalPages(result.pagination.totalPages);
          setTotalRecords(result.pagination.totalRecords);
        } else {
          showNotification(result.message || "Failed to load scope data", "error");
        }

      } catch (error) {
        console.error("Error loading scope master:", error);
      } finally {
        setScopeMasterLoading(false);
      }

    },
    [pageSize, selectedDisciplineId]
  );
  useEffect(() => {
    if (disciplineList.length > 0 && !selectedDisciplineId) {
      setSelectedDisciplineId(disciplineList[0].disciplineId);
    }
  }, [disciplineList]);

  // Fetch facility details
  useEffect(() => {
    const fetchFacilities = async () => {

      const appid = localStorage.getItem('ViewApp_AppId')

      try {
        setFacilitiesLoading(true);
        const response = await LaboratoryService.getFacilityDetails(appid);
        if (response.success) {
          setFacilities(response.data || []);
        }
      } catch (error) {
        console.error("Error fetching facility details:", error);
        setFacilities([]);
      } finally {
        setFacilitiesLoading(false);
      }
    };

    fetchFacilities();
  }, []);
  const handleAddScope = () => {
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
    // Optional: Clear selections when modal is closed
    // setSelectedScopes([]);
    // setSelectedScopeData([]);
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    loadScopeMasterData(newPage, searchQuery);
  };

  // Handle scope selection
  const handleScopeSelection = (scopeId, isSelected) => {
    if (isSelected) {
      setSelectedScopes((prev) => [...prev, scopeId]);
      // Also store the complete scope data
      const scopeData = scopeMasterData.find((scope) => scope.Id === scopeId);
      if (scopeData) {
        setSelectedScopeData((prev) => [...prev, scopeData]);
      }
    } else {
      setSelectedScopes((prev) => prev.filter((id) => id !== scopeId));
      // Remove from selected scope data as well
      setSelectedScopeData((prev) => prev.filter((scope) => scope.Id !== scopeId));
    }
  };

  // Handle select all
  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      const currentPageIds = scopeMasterData.map((scope) => scope.Id);
      setSelectedScopes((prev) => [...new Set([...prev, ...currentPageIds])]);
      // Add current page scope data to selected scope data (avoid duplicates)
      setSelectedScopeData((prev) => {
        const existingIds = prev.map(scope => scope.Id);
        const newScopes = scopeMasterData.filter(scope => !existingIds.includes(scope.Id));
        return [...prev, ...newScopes];
      });
    } else {
      // Deselect all from current page only
      const currentPageIds = scopeMasterData.map((scope) => scope.Id);
      setSelectedScopes((prev) => prev.filter(id => !currentPageIds.includes(id)));
      setSelectedScopeData((prev) => prev.filter(scope => !currentPageIds.includes(scope.Id)));
    }
  };

  // Add selected scopes to existing scopes
  const handleAddSelectedScopes = async () => {
    if (selectedScopes.length === 0) {
      showNotification("Please select at least one scope", "warning");
      return;
    }

    // Use the stored selectedScopeData which contains data from all pages
    const mainOrgId = localStorage.getItem("orgId");
    setLoading(true);
    try {
      const result = await LaboratoryService.saveSelectedScopesEdit(
        selectedScopeData,
        localStorage.getItem("ViewApp_AppId"),
        localStorage.getItem('ViewApp_OrgId'),
        selectedDisciplineId,
        mainOrgId
      );

      if (result.success) {
        showNotification(
          `Added ${result.count} scope(s) successfully`,
          "success"
        );
        setSelectedScopes([]);
        setSelectedScopeData([]); // Clear selected scope data as well
        setModalOpen(false);
        // Reload existing scopes to show the newly added ones
        loadExistingScopes();
      } else {
        showNotification(result.message || "Failed to save scopes", "error");
      }
    } catch (error) {
      console.error("Error saving selected scopes:", error);
      showNotification("Error saving scopes: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const selectedValues = (
    Array.isArray(editFormData.testPerformedAt)
      ? editFormData.testPerformedAt
      : (editFormData.testPerformedAt || "")
        .split(",")
        .map(v => v.trim())
        .filter(Boolean)
  );


  const handleDeleteScope = (scopeId) => {
    setSingleDeleteId(scopeId);
    setDeleteTarget("single");
    setDeleteConfirmOpen(true);
  };
  // Cancel delete
  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
    setSingleDeleteId(null);
    setDeleteTarget(null);
  };
  // Confirm delete action
  const confirmDelete = async () => {
    try {
      setExistingScopesLoading(true);

      if (deleteTarget === "single") {
        const result = await LaboratoryService.deleteExistingScope(
          singleDeleteId
        );
        if (result.success) {
          showNotification("Scope deleted successfully", "success");
          await loadExistingScopes();
        } else {
          showNotification(result.message || "Failed to delete scope", "error");
        }
      } else if (deleteTarget === "multiple") {
        // Delete multiple scopes
        let successCount = 0;
        let errorCount = 0;

        for (const scopeId of selectedExistingScopes) {
          try {
            const result = await LaboratoryService.deleteExistingScope(scopeId);
            if (result.success) {
              successCount++;
            } else {
              errorCount++;
            }
          } catch (error) {
            errorCount++;
          }
        }

        if (successCount > 0) {
          showNotification(
            `${successCount} scope(s) deleted successfully`,
            "success"
          );
          setSelectedExistingScopes([]);
          await loadExistingScopes();
        }

        if (errorCount > 0) {
          showNotification(
            `${errorCount} scope(s) could not be deleted`,
            "error"
          );
        }
      }
    } catch (error) {
      console.error("Error deleting scope:", error);
      showNotification(
        "Error deleting scope: " + (error.message || "Unknown error"),
        "error"
      );
    } finally {
      setExistingScopesLoading(false);
      setDeleteConfirmOpen(false);
      setSingleDeleteId(null);
      setDeleteTarget(null);
    }
  };
  const handleSearch = (searchValue) => {
    setSearchQuery(searchValue);
    setCurrentPage(1);
    loadScopeMasterData(1, searchValue);
  };

  const handleUpdateScope = async () => {
    if (!editingScopeId) return;

    const rangeType = editFormData.rangeType || 'Quantitative';

    if (rangeType === 'Quantitative') {
      if (!editFormData.RangeLL || !editFormData.RangeLLUnit ||
        !editFormData.RangeUL || !editFormData.RangeULUnit) {
        showSnackbar('For Quantitative type, Range Lower Limit, Range LL Unit, Range Upper Limit, and Range UL Unit are required.', 'error');
        return;
      }
    } else if (rangeType === 'Qualitative' || rangeType === 'Calculative' || rangeType === 'Others') {
      if (!editFormData.rangeRemark || !editFormData.rangeRemark.trim()) {
        showSnackbar(`For ${rangeType} type, Range Remarks is required.`, 'error');
        return;
      }
    }

    setEditLoading(true);
    try {
      await LaboratoryService.updateExistingScopeEditCertificate(
        editingScopeId,
        editFormData.rangeRemark,
        editFormData.rangeType,
        editFormData.RangeLL,
        editFormData.RangeLLUnit,
        editFormData.RangeUL,
        editFormData.RangeULUnit,
        editFormData.mu,
        editFormData.cv,
        '',
        editFormData.testPerformedAt,
        editFormData.EquipmentName,
        editFormData.Ref_Id,
        editFormData.Pt_id,
        localStorage.getItem('orgId') || '0'
      );

      showSnackbar('Scope updated successfully!', 'success');

      await loadExistingScopes();

      setEditModalOpen(false);
      setEditingScopeId(null);
      setEditFormData({});
      setEditReadOnlyData({});
    } catch (error) {
      console.error('Error updating scope:', error);
      showSnackbar(error.response?.data?.message || 'Error updating scope', 'error');
    } finally {
      setEditLoading(false);
    }
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setEditingScopeId(null);
    setEditFormData({});
    setEditReadOnlyData({});
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
        <Button
          onClick={() => navigate(`/main/do/decision-process?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&assessmentId=${encryptText(assessmentId)}`)}
          startIcon={<ArrowBack />}
          sx={{ mt: 2 }}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, maxWidth: 1400, mx: "auto" }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: "linear-gradient(135deg, #00024c 0%, #1a2b6b 100%)",
          color: "white",
          borderRadius: 0,
          mb: 3,
        }}
      >
        <Box sx={{ px: 3, py: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar sx={{ bgcolor: "rgba(255,255,255,0.2)", mr: 2, width: 56, height: 56 }}>
                <EditIcon sx={{ fontSize: 28 }} />
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                  Edit Scope Certificate
                </Typography>
                <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                  Update Laboratory and Scope Details
                </Typography>
              </Box>
            </Box>
            <Button
              variant="contained"
              startIcon={<ArrowBack />}
              onClick={() => navigate(`/main/do/decision-process?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&assessmentId=${encryptText(assessmentId)}`)}
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.3)" }
              }}
            >
              Back
            </Button>
          </Box>
        </Box>
      </Paper>

      {/* Tabs */}
      <Paper elevation={3} sx={{ mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": {
              fontWeight: 600,
              fontSize: "1rem",
            },
          }}
        >
          <Tab label="🏢 Lab Details" />
          <Tab label="🔬 Scope Details" />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Paper elevation={3} sx={{ p: 3 }}>
        {activeTab === 0 && (
          <Grid container spacing={3}>
            {/* Lab Details Section */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 600, mt: 2 }}>
                Laboratory Details
              </Typography>
              <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Laboratory Name"
                value={labName}
                onChange={(e) => setLabName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>State/Province</InputLabel>
                <Select
                  value={state}
                  onChange={handleStateChange}
                  label="State/Province"
                >
                  <MenuItem value="">--Select State--</MenuItem>
                  {states.map((s) => (
                    <MenuItem key={s.id} value={s.id}>
                      {s.name || s.State_Name_Eng || s.stateName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth required>
                <InputLabel>City</InputLabel>
                <Select
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  label="City"
                  disabled={!state}
                >
                  <MenuItem value="">--Select City--</MenuItem>
                  {cities.map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                      {c.name || c.City_Name || c.cityName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>District</InputLabel>
                <Select
                  value={district}
                  onChange={handleDistrictChange}
                  label="District"
                  disabled={!state}
                >
                  <MenuItem value="">--Select District--</MenuItem>
                  {districts.map((d) => (
                    <MenuItem key={d.District_Code} value={d.District_Code}>
                      {d.District_Name_Eng}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                multiline
                rows={3}
                label="Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Pin Code"
                value={pincode}
                onChange={(e) => handleNumericChange('pincode', e.target.value, 6)}
                inputProps={{ maxLength: 6 }}
              />
            </Grid>

            {/* Contact Person Section */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 600, mt: 2 }}>
                Contact Person for NABL
              </Typography>
              <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl sx={{ minWidth: 100 }}>
                  <InputLabel>Title</InputLabel>
                  <Select
                    value={salutation}
                    onChange={(e) => setSalutation(e.target.value)}
                    label="Title"
                  >
                    <MenuItem value="Dr.">Dr.</MenuItem>
                    <MenuItem value="Mr.">Mr.</MenuItem>
                    <MenuItem value="Ms.">Ms.</MenuItem>
                    <MenuItem value="Mrs.">Mrs.</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  fullWidth
                  required
                  label="Name"
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Designation"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Mobile No"
                value={mobileNo}
                onChange={(e) => handleNumericChange('mobileNo', e.target.value, 10)}
                inputProps={{ maxLength: 10 }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="STD Code"
                  value={landlineCode}
                  onChange={(e) => setLandlineCode(e.target.value)}
                  sx={{ width: 120 }}
                  inputProps={{ maxLength: 5 }}
                />
                <TextField
                  fullWidth
                  label="Landline No"
                  value={landlineNo}
                  onChange={(e) => setLandlineNo(e.target.value)}
                  inputProps={{ maxLength: 10 }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="STD Code"
                  value={faxCode}
                  onChange={(e) => setFaxCode(e.target.value)}
                  sx={{ width: 120 }}
                  inputProps={{ maxLength: 5 }}
                />
                <TextField
                  fullWidth
                  label="Fax No"
                  value={faxNo}
                  onChange={(e) => setFaxNo(e.target.value)}
                  inputProps={{ maxLength: 10 }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                type="email"
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={email && !validateEmail(email)}
                helperText={email && !validateEmail(email) ? "Invalid email format" : ""}
              />
            </Grid>

            {/* Legal Identity Details Section */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 600, mt: 2 }}>
                Legal Identity Details
              </Typography>
              <Divider sx={{ mb: 2 }} />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                label="Legal Entity Name"
                value={legalEntityName}
                onChange={(e) => setLegalEntityName(e.target.value)}
                helperText="Enter the legal entity name as per registration"
              />
            </Grid>

            {/* Additional Remarks Field with ReactQuill */}
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                Additional Remarks to be included in Certificate, if any
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                Note: Please make the Font Type as "Times New Roman", Font size as "4" and Font Style as "Non-Italic" in the option given inside Text Box
              </Typography>
              <Box sx={{
                border: '1px solid #c4c4c4',
                borderRadius: 1,
                '& .ql-container': {
                  minHeight: '150px',
                  fontSize: '14px'
                },
                '& .ql-editor': {
                  minHeight: '150px'
                }
              }}>
                <ReactQuill
                  theme="snow"
                  value={additionalData}
                  onChange={setAdditionalData}
                  modules={quillModules}
                  formats={quillFormats}
                  placeholder="Enter additional remarks for the certificate..."
                />
              </Box>
            </Grid>

            {/* Action Buttons */}
            <Grid item xs={12} sx={{ textAlign: "center", mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<Save />}
                onClick={handleUpdateLabDetails}
              >
                Update Lab Details
              </Button>
            </Grid>
          </Grid>
        )}

        {activeTab === 1 && (
          <Box>
            {/* Scope Details Section */}
            <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 600, mb: 2 }}>
              Existing Scopes
            </Typography>
            <Divider sx={{ mb: 3 }} />

            {existingScopesLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {/* Search and Pagination Controls */}
                <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                  <TextField
                    size="small"
                    placeholder="Search scopes..."
                    value={existingScopesSearchQuery}
                    onChange={(e) => setExistingScopesSearchQuery(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        setExistingScopesPage(1);
                        loadExistingScopes(1, existingScopesPageSize, existingScopesSearchQuery);
                      }
                    }}
                    sx={{ flex: 1, maxWidth: 300 }}
                  />
                  <FormControl size="small" sx={{ minWidth: 180 }}>
                    <InputLabel>Adequacy</InputLabel>
                    <Select
                      value={adequacyFilter}
                      label="Adequacy"
                      onChange={(e) => {
                        setAdequacyFilter(e.target.value);
                        loadExistingScopes(
                          1,
                          existingScopesPageSize,
                          existingScopesSearchQuery,
                          e.target.value
                        );
                      }}
                    >
                      {/* <MenuItem value="All">All</MenuItem> */}
                      <MenuItem value="Adequate">Adequate</MenuItem>
                      <MenuItem value="Inadequate">Inadequate</MenuItem>
                      <MenuItem value="Pending">Pending</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setExistingScopesPage(1);
                      loadExistingScopes(
                        1,
                        existingScopesPageSize,
                        existingScopesSearchQuery,
                        adequacyFilter
                      );
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleOpenBulkAdequacyModal}
                    disabled={selectedAdequacyScopes.length === 0}
                    sx={{ ml: 1 }}
                  >
                    📤 Bulk Adequacy Mark
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={handleAddScope}
                    size="small"
                  >
                    Add Scope
                  </Button>
                  <Button
                    variant="outlined"
                    color="info"
                    size="small"
                    onClick={handleOpenPullAppModal}
                    disabled={hasPulled}
                    title={hasPulled ? 'Data already pulled from a previous application' : ''}
                  >
                    📥 Pull from Previous App
                  </Button>
                  <FormControl size="small" sx={{ minWidth: 100 }}>
                    <InputLabel>Per Page</InputLabel>
                    <Select
                      value={existingScopesPageSize}
                      onChange={(e) => {
                        const newPageSize = e.target.value;
                        setExistingScopesPageSize(newPageSize);
                        setExistingScopesPage(1);
                        loadExistingScopes(1, newPageSize, existingScopesSearchQuery);
                      }}
                      label="Per Page"
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                {/* Pagination Info */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Showing {existingScopes.length} of {existingScopesTotalRecords} results
                  </Typography>
                  <Typography variant="body2" color="primary">
                    Page {existingScopesPage} of {existingScopesTotalPages}
                  </Typography>
                </Box>

                <TableContainer component={Paper} sx={{ maxHeight: 600, boxShadow: 'none', border: '1px solid #e2e8f0', overflowX: 'auto' }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                        <TableCell sx={{ fontWeight: 600, minWidth: 40 }}>
                          <Checkbox
                            size="small"
                            checked={existingScopes.length > 0 && selectedAdequacyScopes.length === existingScopes.length}
                            indeterminate={selectedAdequacyScopes.length > 0 && selectedAdequacyScopes.length < existingScopes.length}
                            onChange={(e) => handleSelectAllAdequacyScopes(e.target.checked)}
                          />
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 60 }}>Sr No.</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 150 }}>Discipline Name</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 300 }}>Scope Details</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 280 }}>Range Details</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 280 }}>Adequacy check</TableCell>
                        <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {existingScopes.map((scope, index) => {
                        // ✅ STEP 1: SPLIT VALUES
                        const facilities = scope.testPerformedAt
                          ? scope.testPerformedAt.split(",").map(f => f.trim())
                          : [];

                        // ✅ STEP 2: MAP VALUES
                        const facilityMap = {
                          MobileFacility: "POCT (Point of Care Testing)",
                          TemporaryFacility: "Temporary Facility",
                          PermanentFacility: "Permanent Facility"
                        };

                        const formattedFacilities = facilities.map(
                          f => facilityMap[f] || f
                        );
                        return (
                          <TableRow key={scope.Id} sx={{ '&:hover': { backgroundColor: '#f8fafc' } }}>
                            <TableCell>
                              <Checkbox
                                size="small"
                                checked={selectedAdequacyScopes.includes(scope.Id)}
                                onChange={(e) => handleAdequacyScopeSelection(scope.Id, e.target.checked)}
                              />
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2' }}>
                                {(existingScopesPage - 1) * existingScopesPageSize + index + 1}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2' }}>
                                {scope.disciplineName || 'NA'}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography variant="caption" sx={{ fontSize: '0.875rem' }}>
                                  {scope.TestCode || 'NA'}, {scope.GroupTested}, {scope.TypeOfTest}, {scope.ScopeStandard}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography variant="caption" sx={{ fontWeight: 600, color: '#6a1b9a', fontSize: '0.7rem', minWidth: 60 }}>
                                    Type:
                                  </Typography>
                                  <Chip label={scope.rangeType || 'Quantitative'} size="small" color={scope.rangeType === 'Qualitative' ? 'secondary' : scope.rangeType === 'Calculative' ? 'warning' : scope.rangeType === 'Others' ? 'info' : 'primary'} />
                                </Box>
                                {scope.rangeType === 'Quantitative' && (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 600, color: '#1565c0', fontSize: '0.7rem', minWidth: 60 }}>
                                      Range:
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                      {scope.RangeLL || 'N/A'} {scope.RangeLLUnit || 'N/A'} to {scope.RangeUL || 'N/A'} {scope.RangeULUnit || 'N/A'}
                                    </Typography>
                                  </Box>
                                )}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography variant="caption" sx={{ fontWeight: 600, color: '#1565c0', fontSize: '0.7rem', minWidth: 60 }}>
                                    Facility:
                                  </Typography>
                                  {formattedFacilities.length > 0 ? (
                                    formattedFacilities.map((f, i) => (
                                      <Chip
                                        key={i}
                                        label={f}
                                        size="small"
                                        sx={{ mr: 0.5 }}
                                        color={
                                          f === "Permanent Facility"
                                            ? "primary"
                                            : f === "POCT (Point of Care Testing)"
                                              ? "success"
                                              : "default"
                                        }
                                      />
                                    ))
                                  ) : (
                                    <Typography variant="body2">N/A</Typography>
                                  )}
                                </Box>
                                {(scope.rangeType === 'Qualitative' || scope.rangeType === 'Calculative' || scope.rangeType === 'Others') && (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="caption" sx={{ fontWeight: 600, color: '#558b2f', fontSize: '0.7rem', minWidth: 60 }}>
                                      Remarks:
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontSize: '0.875rem', fontStyle: 'italic' }}>
                                      {scope.rangeRemark || 'N/A'}
                                    </Typography>
                                  </Box>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                <Chip
                                  label={scope.InformationStatus ? scope.InformationStatus : 'N/A'}
                                  size="small"
                                  color={scope.InformationStatus === 'Adequate' ? 'success' : 'error'}
                                />
                                {scope.InformationStatus === 'Inadequate' && scope.Observation && (
                                  <Typography variant="caption" sx={{ fontSize: '0.75rem', color: '#d32f2f' }}>
                                    {scope.Observation || scope.InformationProvided}
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell>
                              <IconButton
                                size="small"
                                onClick={() => handleEditScope(scope)}
                                sx={{ color: '#1976d2' }}
                                title="Edit"
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                              {/* <IconButton
                              size="small"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleDeleteScope(scope.Id);
                              }}
                              sx={{ color: "#d32f2f", p: 0.5 }}
                              title="Delete"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton> */}
                            </TableCell>
                          </TableRow>
                        )
                      })}
                      {existingScopes.length === 0 && !existingScopesLoading && (
                        <TableRow>
                          <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                            <Typography color="text.secondary">No scopes available</Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination Controls */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={existingScopesPage === 1}
                    onClick={() => {
                      const newPage = existingScopesPage - 1;
                      setExistingScopesPage(newPage);
                      loadExistingScopes(newPage, existingScopesPageSize, existingScopesSearchQuery);
                    }}
                  >
                    Previous
                  </Button>

                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    {[...Array(Math.min(5, existingScopesTotalPages))].map((_, index) => {
                      const startPage = Math.max(1, existingScopesPage - 2);
                      const pageNum = startPage + index;

                      if (pageNum > existingScopesTotalPages) return null;

                      return (
                        <Button
                          key={pageNum}
                          variant={pageNum === existingScopesPage ? 'contained' : 'outlined'}
                          size="small"
                          onClick={() => {
                            setExistingScopesPage(pageNum);
                            loadExistingScopes(pageNum, existingScopesPageSize, existingScopesSearchQuery);
                          }}
                          sx={{ minWidth: 40 }}
                        >
                          {pageNum}
                        </Button>
                      );
                    })}
                  </Box>

                  <Button
                    variant="outlined"
                    size="small"
                    disabled={existingScopesPage === existingScopesTotalPages}
                    onClick={() => {
                      const newPage = existingScopesPage + 1;
                      setExistingScopesPage(newPage);
                      loadExistingScopes(newPage, existingScopesPageSize, existingScopesSearchQuery);
                    }}
                  >
                    Next
                  </Button>
                </Box>
              </>
            )}
          </Box>
        )}
      </Paper>

      {/* Edit Scope Modal */}
      <Dialog
        open={editModalOpen}
        onClose={handleCloseEditModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { maxHeight: '80vh' },
        }}
      >
        <DialogTitle>
          <Typography variant="h6">Edit Scope</Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 2 }}>
            {/* Read-only fields */}
            <Card sx={{ p: 2, backgroundColor: '#f8fafc' }}>
              <Typography variant="subtitle2" sx={{ mb: 2, color: 'text.secondary' }}>
                Scope Information (Read-only)
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Test Code"
                    value={editReadOnlyData.TestCode || ''}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                    sx={{ '& .MuiInputBase-input': { color: 'text.secondary' } }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Discipline Name"
                    value={editReadOnlyData.disciplineName || ''}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                    sx={{ '& .MuiInputBase-input': { color: 'text.secondary' } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Materials/Products Tested"
                    value={editReadOnlyData.GroupTested || ''}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                    sx={{ '& .MuiInputBase-input': { color: 'text.secondary' } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Specific Test Performed"
                    value={editReadOnlyData.TypeOfTest || ''}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                    sx={{ '& .MuiInputBase-input': { color: 'text.secondary' } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Test Method / Equipment Used"
                    value={editReadOnlyData.ScopeStandard || ''}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                    sx={{ '& .MuiInputBase-input': { color: 'text.secondary' } }}
                  />
                </Grid>
              </Grid>
            </Card>

            {/* Editable fields */}
            <Card sx={{ p: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 2 }}>
                Editable Information
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Range Type"
                    value={editFormData.rangeType || 'Quantitative'}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                    sx={{ '& .MuiInputBase-input': { color: 'text.primary', backgroundColor: '#f5f5f5' } }}
                  />
                </Grid>

                {editFormData.rangeType === 'Quantitative' && (
                  <>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label="Range Lower Limit"
                        value={editFormData.RangeLL || ''}
                        onChange={(e) => setEditFormData((prev) => ({ ...prev, RangeLL: e.target.value }))}
                        fullWidth
                        size="small"
                        required
                        error={editFormData.rangeType === 'Quantitative' && !editFormData.RangeLL}
                        helperText={editFormData.rangeType === 'Quantitative' && !editFormData.RangeLL ? 'Required' : ''}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label="Range LL Unit"
                        value={editFormData.RangeLLUnit || ''}
                        onChange={(e) => setEditFormData((prev) => ({ ...prev, RangeLLUnit: e.target.value }))}
                        fullWidth
                        size="small"
                        required
                        error={editFormData.rangeType === 'Quantitative' && !editFormData.RangeLLUnit}
                        helperText={editFormData.rangeType === 'Quantitative' && !editFormData.RangeLLUnit ? 'Required' : ''}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label="Range Upper Limit"
                        value={editFormData.RangeUL || ''}
                        onChange={(e) => setEditFormData((prev) => ({ ...prev, RangeUL: e.target.value }))}
                        fullWidth
                        size="small"
                        required
                        error={editFormData.rangeType === 'Quantitative' && !editFormData.RangeUL}
                        helperText={editFormData.rangeType === 'Quantitative' && !editFormData.RangeUL ? 'Required' : ''}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label="Range UL Unit"
                        value={editFormData.RangeULUnit || ''}
                        onChange={(e) => setEditFormData((prev) => ({ ...prev, RangeULUnit: e.target.value }))}
                        fullWidth
                        size="small"
                        required
                        error={editFormData.rangeType === 'Quantitative' && !editFormData.RangeULUnit}
                        helperText={editFormData.rangeType === 'Quantitative' && !editFormData.RangeULUnit ? 'Required' : ''}
                      />
                    </Grid>
                  </>
                )}

                {(editFormData.rangeType === 'Qualitative' || editFormData.rangeType === 'Calculative' || editFormData.rangeType === 'Others') && (
                  <Grid item xs={12}>
                    <TextField
                      label="Range Remarks"
                      value={editFormData.rangeRemark || ''}
                      onChange={(e) => setEditFormData((prev) => ({ ...prev, rangeRemark: e.target.value }))}
                      fullWidth
                      size="small"
                      multiline
                      rows={2}
                      required
                      error={(editFormData.rangeType === 'Qualitative' || editFormData.rangeType === 'Calculative' || editFormData.rangeType === 'Others') && !editFormData.rangeRemark}
                      helperText={(editFormData.rangeType === 'Qualitative' || editFormData.rangeType === 'Calculative' || editFormData.rangeType === 'Others') && !editFormData.rangeRemark ? 'Required' : ''}
                      placeholder="Enter remarks for qualitative, calculative, or other range types"
                    />
                  </Grid>
                )}

                {/* <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Test Performed At</InputLabel>
                    <Select
                      value={editFormData.testPerformedAt || ''}
                      onChange={(e) => setEditFormData((prev) => ({ ...prev, testPerformedAt: e.target.value }))}
                      label="Test Performed At"
                    >
                      <MenuItem value="PermanentFacility">Permanent Facility</MenuItem>
                      <MenuItem value="TemporaryFacility">Site Facility</MenuItem>
                      <MenuItem value="SiteOfCustomer">POCT</MenuItem>
                    </Select>
                  </FormControl>
                </Grid> */}

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Test Performed At</InputLabel>


                    <Select
                      multiple
                      value={selectedValues}
                      onChange={(e) => {
                        const value = e.target.value;

                        setEditFormData((prev) => ({
                          ...prev,
                          testPerformedAt: value.join(", "),
                        }));
                      }}
                    >
                      {facilities.map((facility) => (
                        <MenuItem key={facility.FacilityName} value={facility.FacilityName}>
                          <Checkbox checked={selectedValues.includes(facility.FacilityName)} />
                          <Typography>
                            {facility.FacilityName === "MobileFacility"
                              ? "POCT (Point of Care Testing)"
                              : facility.FacilityLabel}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="MU"
                    value={editFormData.mu || ''}
                    onChange={(e) => setEditFormData((prev) => ({ ...prev, mu: e.target.value }))}
                    fullWidth
                    size="small"
                    type="number"
                    placeholder="Enter measurement uncertainty"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="CV"
                    value={editFormData.cv || ''}
                    onChange={(e) => setEditFormData((prev) => ({ ...prev, cv: e.target.value }))}
                    fullWidth
                    size="small"
                    placeholder="Enter coefficient of variation"
                  />
                </Grid>
              </Grid>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button onClick={handleCloseEditModal} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleUpdateScope}
            variant="contained"
            disabled={
              editLoading ||
              (editFormData.rangeType === 'Quantitative' && (!editFormData.RangeLL || !editFormData.RangeLLUnit || !editFormData.RangeUL || !editFormData.RangeULUnit)) ||
              ((editFormData.rangeType === 'Qualitative' || editFormData.rangeType === 'Calculative' || editFormData.rangeType === 'Others') && !editFormData.rangeRemark?.trim())
            }
            startIcon={editLoading ? <CircularProgress size={20} /> : <Save />}
          >
            {editLoading ? 'Updating...' : 'Update Scope'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={modalOpen}
        onClose={handleModalClose}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: { height: "90vh" },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Add Scopes from Master Data</Typography>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <TextField
                size="small"
                placeholder="Search scopes..."
                value={searchQuery}
                onChange={(e) => handleSearch(e.target.value)}
                sx={{ width: 250 }}
              />
              <FormControl size="small" sx={{ minWidth: 100 }}>
                <InputLabel>Per Page</InputLabel>
                <Select
                  value={pageSize}
                  onChange={(e) => {
                    setPageSize(e.target.value);
                    setCurrentPage(1);
                    loadScopeMasterData(1, searchQuery);
                  }}
                  label="Per Page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 250 }}>
                <InputLabel>Select Discipline</InputLabel>
                <Select
                  value={selectedDisciplineId}
                  label="Select Discipline"
                  onChange={(e) => {
                    setSelectedDisciplineId(e.target.value);
                    loadScopeMasterData(1, "", e.target.value);
                  }}
                >
                  {disciplineList.map((d) => (
                    <MenuItem key={d.DisciplineId} value={d.DisciplineId}>
                      {d.disciplineName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          {scopeMasterLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  Showing {scopeMasterData.length} of {totalRecords} results
                </Typography>
                <Typography variant="body2" color="primary">
                  {selectedScopes.length} selected
                </Typography>
              </Box>

              <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <input
                          type="checkbox"
                          checked={
                            selectedScopes.length === scopeMasterData.length &&
                            scopeMasterData.length > 0
                          }
                          onChange={(e) => handleSelectAll(e.target.checked)}
                        />
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Test Code</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Discipline Name
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Materials or Products tested
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Component, parameter or characteristic tested
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Test Method Specification
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Qualitative/Quantitative
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>
                        PT Availability
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {scopeMasterData.map((scope) => (
                      <TableRow
                        key={scope.Id}
                        sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}
                      >
                        <TableCell padding="checkbox">
                          <input
                            type="checkbox"
                            checked={selectedScopes.includes(scope.Id)}
                            onChange={(e) =>
                              handleScopeSelection(scope.Id, e.target.checked)
                            }
                          />
                        </TableCell>
                        <TableCell>{scope.TestCode}</TableCell>
                        <TableCell>{scope.DisciplineName}</TableCell>
                        <TableCell>{scope.GroupTested}</TableCell>
                        <TableCell>{scope.TypeOfTest}</TableCell>
                        <TableCell>{scope.ScopeStandard}</TableCell>
                        <TableCell>
                          <Chip
                            label={scope.Category}
                            size="small"
                            color={
                              scope.Category === "Quantitative"
                                ? "primary"
                                : "secondary"
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={scope.PTAvailable}
                            size="small"
                            color={
                              scope.PTAvailable === "Yes"
                                ? "success"
                                : "default"
                            }
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                    {scopeMasterData.length === 0 && !scopeMasterLoading && (
                      <TableRow>
                        <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                          <Typography color="text.secondary">
                            No scope data found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              {/* Pagination */}
              {totalPages > 1 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: 2,
                    gap: 1,
                  }}
                >
                  <Button
                    size="small"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                      const pageNum = Math.max(1, currentPage - 2) + i;
                      if (pageNum > totalPages) return null;

                      return (
                        <Button
                          key={pageNum}
                          size="small"
                          variant={
                            pageNum === currentPage ? "contained" : "outlined"
                          }
                          onClick={() => handlePageChange(pageNum)}
                          sx={{ minWidth: 40 }}
                        >
                          {pageNum}
                        </Button>
                      );
                    })}
                  </Box>

                  <Button
                    size="small"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>

                  <Typography variant="body2" sx={{ ml: 2 }}>
                    Page {currentPage} of {totalPages}
                  </Typography>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleModalClose}
            startIcon={<CancelIcon />}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddSelectedScopes}
            variant="contained"
            disabled={selectedScopes.length === 0}
            startIcon={<SaveIcon />}
          >
            Add Selected ({selectedScopes.length})
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Adequacy Modal */}
      <Dialog
        open={bulkAdequacyModalOpen}
        onClose={handleCloseBulkAdequacyModal}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle>Bulk Adequacy Mark</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
            <FormControl fullWidth>
              <InputLabel>Document Status</InputLabel>
              <Select
                value={bulkAdequacyStatus}
                onChange={(e) => setBulkAdequacyStatus(e.target.value)}
                label="Document Status"
              >
                <MenuItem value="">-- Select Status --</MenuItem>
                <MenuItem value="Adequate">Adequate</MenuItem>
                <MenuItem value="Inadequate">Inadequate</MenuItem>
              </Select>
            </FormControl>

            {bulkAdequacyStatus === 'Inadequate' && userTypeId === '6' && (
              <FormControl fullWidth>
                <InputLabel>Clause Number</InputLabel>
                <Select
                  value={selectedClause || ''}
                  onChange={(e) => setSelectedClause(e.target.value)}
                  label="Clause Number"
                >
                  <MenuItem value="">-- Select Clause --</MenuItem>
                  {clauseList.map((c, idx) => (
                    <MenuItem key={idx} value={c}>
                      {c?.ClauseNo || c?.DisplayName || c}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {bulkAdequacyStatus === 'Inadequate' && (
              <Autocomplete
                fullWidth
                freeSolo
                loading={bulkLoadingRemarks}
                options={bulkScrutinyRemarks}
                getOptionLabel={(option) => (typeof option === 'string' ? option : option?.inadequate_remarks || option?.text || '')}
                value={bulkAdequacyRemarks}
                onChange={(e, newVal) => setBulkAdequacyRemarks(typeof newVal === 'string' ? newVal : newVal?.inadequate_remarks || '')}
                onInputChange={(e, newInput) => setBulkAdequacyRemarks(newInput)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Remarks${bulkScrutinyRemarks.length ? ` - ${bulkScrutinyRemarks.length} suggestions` : ''}`}
                    multiline
                    rows={3}
                  />
                )}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button onClick={handleCloseBulkAdequacyModal} sx={{ color: '#6c757d' }}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleBulkAdequacySubmit}
            disabled={bulkAdequacyLoading || !bulkAdequacyStatus || (bulkAdequacyStatus === 'Inadequate' && !bulkAdequacyRemarks?.trim()) || (bulkAdequacyStatus === 'Inadequate' && userTypeId === '6' && !selectedClause)}
          >
            {bulkAdequacyLoading ? 'Submitting...' : 'Submit Bulk Adequacy'}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={cancelDelete}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <DeleteIcon sx={{ color: "#d32f2f" }} />
            <Typography variant="h6">Confirm Delete</Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography id="delete-dialog-description">
            {deleteTarget === "single"
              ? "Are you sure you want to delete this scope? This action cannot be undone."
              : `Are you sure you want to delete ${selectedExistingScopes.length} selected scope(s)? This action cannot be undone.`}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={cancelDelete} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={confirmDelete}
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            disabled={existingScopesLoading}
          >
            {existingScopesLoading ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>


      {/* Pull Confirmation Dialog */}
      <Dialog open={pullConfirmOpen} onClose={handleCancelPull} maxWidth="sm" fullWidth>
        <DialogTitle>Confirm Pull from Previous Application</DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight={600}>
              This action can only be performed once.
            </Typography>
          </Alert>
          <Typography variant="body2">
            Once you pull data from a previous application, this functionality will be permanently disabled for this application. Do you want to proceed?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelPull} variant="outlined" color="inherit">Cancel</Button>
          <Button onClick={handleConfirmPull} variant="contained" color="warning">
            Yes, Pull Data
          </Button>
        </DialogActions>
      </Dialog>

      {/* Pull From Previous Application Modal */}
      <Dialog
        open={pullAppModalOpen}
        onClose={handleClosePullAppModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Select Application to Pull Data From</Typography>
            <IconButton onClick={handleClosePullAppModal} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {pullAppLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper} sx={{ mt: 1 }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                    <TableCell sx={{ fontWeight: 600 }}>Sr No.</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Application No</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Lab Type</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Assessment Type</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Issue Date</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pullAppList.map((app, index) => (
                    <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f8fafc' } }}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#1976d2' }}>
                          {app.ApplicationNo || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>{app.LabType || 'N/A'}</TableCell>
                      <TableCell>
                        <Chip label={app.assessmenttype || 'N/A'} size="small" color="primary" variant="outlined" />
                      </TableCell>
                      <TableCell>{app.Issue_Date || 'N/A'}</TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                          {app.Description || 'N/A'}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          size="small"
                          color="success"
                          onClick={() => handleRequestPull(app.AppId, index)}
                          disabled={pullingFromAppId !== null}
                          startIcon={pullingFromAppId === index ? <CircularProgress size={14} color="inherit" /> : null}
                        >
                          {pullingFromAppId === index ? 'Pulling...' : 'Pull'}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  {pullAppList.length === 0 && !pullAppLoading && (
                    <TableRow>
                      <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                        <Typography color="text.secondary">No other applications found</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePullAppModal} variant="outlined">Close</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EditScopeCertificate;
